
import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { Slider } from '../common/Slider';
import IconButton from '../common/IconButton';
import ReflowableContentUIAction from '../../actions/ui/ReflowableContentUIAction';

interface ReflowableContentSettingLineHeightSliderProps {
  readonly lineHeight: number;
  readonly dispatch: Dispatch<Action>;
}

const minValue = 0.5;
const maxValue = 3;

const trackMarkerStyle: React.CSSProperties = {
  position: 'absolute',
  transform: 'translate(-50%, -50%)',
  top: '-23px',
  fontSize: '0.75em',
  fontWeight: 'bold',
  width: 100,
  textAlign: 'center',
};

const barStyle: React.CSSProperties = {
  background: '#3b3328',
  border: '1px solid #82807f',
  borderRadius: '7px',
};

const gripStyle: React.CSSProperties = {
  backgroundColor: 'transparent',
  backgroundImage: 'url("images/setting-popup/slide-bar/slide_bar_knob.png")',
  backgroundSize: 'contain',
  border: 'none',
};

const buttonStyle: React.CSSProperties = {
  width: '78px',
  height: '44px',
  margin: '10px 3px 10px 3px',
};

const ReflowableContentSettingLineHeightSlider: React.SFC<
  ReflowableContentSettingLineHeightSliderProps
> = React.memo((props) => {
  const { lineHeight, dispatch } = props;

  const roundedLineHeight = Math.round(lineHeight * 10) / 10;

  return (
    <Slider
      vertical={false}
      enabled={true}
      value={roundedLineHeight}
      sliderLength={220}
      sliderWidth={7}
      barStyle={barStyle}
      gripSize={30}
      gripStyle={gripStyle}
      step={0.1}
      onChange={(value) => {
        ReflowableContentUIAction.setLineHeight(value, dispatch);
      }}
      renderIncrementButton={() => {
        return (
          <IconButton
            title="+"
            style={buttonStyle}
            svgStyle={buttonStyle}
            imagePath="images/setting-popup/slide-bar/btn_between_lines_wide"
            disabled={roundedLineHeight >= maxValue}
            onClick={() => {
              ReflowableContentUIAction.setLineHeight(roundedLineHeight + 0.1, dispatch);
            }} />
        );
      }}
      renderDecrementButton={() => {
        return (
          <IconButton
            title="-"
            style={buttonStyle}
            svgStyle={buttonStyle}
            imagePath="images/setting-popup/slide-bar/btn_between_lines_narrow"
            disabled={roundedLineHeight <= minValue}
            onClick={() => {
              ReflowableContentUIAction.setLineHeight(roundedLineHeight - 0.1, dispatch);
            }} />
        );
      }}
      renderTrackMarker={() => {
        return (
          <div style={trackMarkerStyle}>{roundedLineHeight}倍</div>
        );
      }}
      minValue={minValue}
      maxValue={maxValue} />
  );
});

export default ReflowableContentSettingLineHeightSlider;
